//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionEditCircle(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor" /><path d="M7.5 14.5V16.5H9.5L14.53 11.47L12.53 9.47L7.5 14.5Z" fill="currentColor" /><path d="M14.9957 7.0001L13.5815 8.4143L15.5826 10.4154L16.9968 9.00119L14.9957 7.0001Z" fill="currentColor" /></svg>;
}
export default IconActionEditCircle;